<template>
  <div v-if="this.$store.state.ResetrouterNavWidth!=0">
       <div class="left-div"  :style='{width:(this.$store.state.ResetrouterNavWidth)+"px"}'>
          <div class="common-space-between common-items-center nameNav">
            <span>设备大类</span>
            <div class="warp-i" @click="addBtn"><i class="el-icon-plus"/></div>
          </div>
          <div class="warp" :style='{height:(this.$store.state.windowHeight-186)+"px"}'>
            <div v-for="(item,index) in list" :key="index">
                <!--未禁用-->
                <div v-if="item.enabled*1==1" class="common-space-between navBtn btn " :class='[index == indexNo? "active":""]'  @click="selectBtn(item,index)">
                    <div class="name">{{item.name}}</div>
                    <span class="eidt" @click.stop="editorBtn(item)">编辑</span>
                    <!-- <span class="eidt" @click.stop="deleteBtn(item)">删除</span>  -->
                </div>
                <!--禁用-->
                <div v-else class="common-space-between navBtn btndisable btn" :class='[index == indexNo? "active":""]'  @click="selectBtn(item,index)">
                    <div class="name">{{item.name}}</div>
                    <span class="eidt" @click.stop="editorBtn(item)">编辑</span>
                    <!-- <span class="eidt" @click.stop="deleteBtn(item)">删除</span> -->
                </div>
              </div>
          </div>
       </div>
       <!--更改弹窗-->
       <el-dialog :title="title"  :visible.sync="showWindow" :close-on-click-modal="false" :destroy-on-close="true" :before-close="closedBtn" :show-close="true" width="420px">
            <el-form :model="formDate" status-icon ref="formDate" :rules="rules" label-width="70px" class="demo-ruleForm">
                <el-form-item  label="设备大类" prop="name">
                    <el-input v-model="formDate.name" :size="this.$store.state.popSize" maxlength="9" placeholder="请输入设备大类" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="大类状态">
                    <SelectBlock keyVal="enabled" ref="enabled" :size="this.$store.state.popSize" title="" placeholder="请选择菜单状态"  left="0" right="0" :options="liststate" width="310" @getVal="getValue" />
                </el-form-item>
                <el-form-item  label="位置排序" prop="orderNo">
                     <el-input-number v-model="formDate.orderNo" :size="this.$store.state.popSize" controls-position="right" @change="handleChange" :min="1"  style="width:310px"></el-input-number>
                </el-form-item>
                <el-form-item  label="大类备注" prop="simpleName" >
                    <el-input type="textarea" v-model="formDate.marks" :size="this.$store.state.popSize" maxlength="30" placeholder="请输入备注信息" autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="closedBtn">取消</el-button>
                            <el-button type="primary"  v-if="showBtn">
                              <i class="el-icon-loading"></i>提交
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </el-dialog>
  </div>
</template>
<script>
  import {iotApi} from '@/utils/config'
  import store from '@/utils/store'
  import {postFun,putFun,getFun,deleteFun} from '@/utils/httpFun'
  import {isEmpty} from '@/utils/util'
  export default{
    data:()=>({
          rules:{
             name:[{validator:isEmpty, trigger:'blur'}]
          },
          title:"设备分类信息",
          showWindow:false, 
          indexNo:0,
          Dids:0,
          mark:"add",
          showBtn:false,
          liststate:[
              { indexNo: '1', selectName: '启用'}, 
              { indexNo: '0', selectName: '禁用'}
          ],
          formDate: {
              parentId:0,    //父ID
              name: '',      //设备大类名称
              marks: "",
              orderNo:1,
              enabled:"0",
            
          },
          list:[],
          execute:true
       
    }),
    created(){
        this.getList()
        store.commit({
            type: "setEmptyText",
            emptyText:"请输入设备大类",
        })
    },
    methods:{
      
       //获取数据 
        async getList(){
          let parms = {
              parentId:0,
          }
          await postFun(iotApi.FACILITYlIST,parms,res=>{
             this.list = res.data
             if(this.execute){
                this.selectBtn(res.data[0],0)
             }
          })
        },

        //禁用启用下拉
        getValue(ev){
            this.formDate.enabled = ev.indexNo 
        },

        //编辑排序
        handleChange(ev){
           this.formDate.orderNo = ev
        },

        //选择启用禁用
        selectBtn(ev,indexNo){ 
          //禁止重复点击
          //  if(this.indexNo == indexNo){
          //     return 
          //  }
           this.indexNo = indexNo
           this.$emit("getVal",ev)
        },

        //新增
        addBtn(){
           this.execute = false
           this.mark = "add"
           this.showWindow = true 
           this.formDate.orderNo = this.list.length+1
           this.$nextTick(res=>{
              this.$refs.enabled.setVal("禁用")
           })
        },

        //编辑
        editorBtn(ev){
          this.execute = false
          this.Dids = ev.id
          this.mark = "eidt"
          this.formDate = {
              name:ev.name,
              marks:ev.marks,
              orderNo:ev.sort*1,
              enabled:ev.enabled+""
          } 
          this.showWindow = true
          this.$nextTick(res=>{
              this.$refs.enabled.setVal(ev.enabled*1==0?"禁用":"启用")
           })
        },
        


        //删除
        async deleteBtn(ev){
          await deleteFun(iotApi.BRANCHDELETE+"/"+ev.id,{},res=>{
             this.getList()
          })
        },

        //提交
        submitForm(formDate) {
            this.$refs[formDate].validate((valid) => {
                if (valid) {
                      this.submit()
                    }else{
                      return false;
                }
            });
        },
        
        //提交
        async submit(){
          let parms = {
              parentId:this.formDate.parentId,
              name:this.formDate.name,
              code:"",
              marks:this.formDate.marks,
              enabled:this.formDate.enabled,
              sort:this.formDate.orderNo,
              state:0,
          }
          this.showBtn = true
          //新增
          if(this.mark=="add"){
            parms.logo = ""
            parms.operator = this.$store.state.operator
            await postFun(iotApi.FACILITYADD,parms,res=>{
              
              if(res.data== true){
                this.closedBtn()
                this.getList()
              }else{
                this.$message.warning("添加失败"); 
              }
            })
          }
          //修改
          if(this.mark=="eidt"){
              delete parms.parentId
              delete parms.code 
              parms.id = this.Dids
              parms.operator = this.$store.state.operator
              await putFun(iotApi.FACILITYEIDT,parms,res=>{
                this.showBtn = false
                this.closedBtn()
                this.getList()
              })
          }
        },

        //关闭
        closedBtn(){
            this.formDate = {
              name:"",
              marks:"",
              orderNo:1,
              enabled:"0"
           } 
           this.showWindow = false
        }
    }
  }
</script>
<style lang="scss" scoped>
   .left-div{
         box-sizing: border-box;
        .nameNav{
            height: 56px;
            width: 100%;
            padding: 0 15px;
            background-color: #FFFFFF;
            border-bottom: 1px solid rgba(205, 216, 233, 0.19);
            box-sizing: border-box;
            overflow: hidden;
            font-size: 14px;
            color: #4D5C72;
            padding-top: 10px;
            .warp-i{cursor: pointer;}
        }
        .warp{
           padding: 15px;
           box-sizing: border-box;
           overflow-y: auto;
        }
        .navBtn{
          border-radius: 6px;
          height: 40px;
          margin-bottom: 10px;
          padding:0 10px;
          box-sizing: border-box;
          line-height: 40px; 
          cursor: pointer;
          border-radius: 6px;
          .name{
            width:115px;
            overflow:hidden;
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
          .eidt{
            font-size: 12px;
            color: #1873FF;
            }
        }
        .btn{
          background:rgba(180,180,180,0.1);
          .name{
            text-decoration: none;
            color:#4D5C72;
          }
        }
      
        .btn.active{
          background:rgba(24,115,255,0.1);
          border-radius: 6px;
        }
        .btndisable{
          background-color: #FCFCFE;
          .name{
            text-decoration: line-through;
            color: rgba(77, 92, 114, 0.3);
          }
        }
        .btndisable.active{
            background:rgba(24,115,255,0.1);
        }


  }
  .dialog-footer{
      display: flex;
      justify-content: flex-end;
  }
  .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
    }
  }
</style>